import { Record } from 'immutable';

const CabSizeRecord = Record({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configurationIds: {},
});

class CabSize extends CabSizeRecord {}

export default CabSize;
